// extracted by mini-css-extract-plugin
module.exports = {"digitInput":"DigitInput_digitInput__27hIm"};